/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Shared layout for all policy / information pages.
 * Children should be plain prose blocks (h2, p, ul, etc.).
 */
const LegalPage = ({ eyebrow, title, italicTail, lastUpdated, children }) => {
  return (
    <main className="bg-[#f5f1e6] min-h-screen text-[#1a1410]">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 pt-12 lg:pt-16 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] text-[#3a2e26] border-b border-[#cdc2b1] pb-1 hover:text-[#1a1410]">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.4} /> RETURN TO MAISON
        </Link>

        <div className="mt-12">
          {eyebrow && (
            <div className="text-[11px] tracking-[0.28em] text-[#3a2e26] border-t border-[#1a1410] pt-3 inline-block">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif text-[44px] lg:text-[56px] leading-[1.05] mt-6">
            {title}
            {italicTail && <> <span className="italic">{italicTail}</span></>}
          </h1>
          {lastUpdated && (
            <p className="mt-3 text-[11px] tracking-[0.22em] text-[#7a6a5a] uppercase">Last updated · {lastUpdated}</p>
          )}
        </div>

        <article className="mt-12 legal-prose">
          {children}
        </article>

        <div className="mt-16 pt-6 border-t border-[#e5dfd0] text-xs tracking-[0.22em] text-[#7a6a5a]">
          VELOUVA · MAISON DU ROUGE · COMPOSED IN PUNE
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
